import React from 'react'
import { PlanCardProps } from '../Utilities/Interfaces';
import { Badge, BlockStack, Button, Card, Divider, Icon, InlineStack, Link, Text, Tooltip } from '@shopify/polaris';
import { FormatPriceAmount } from '../Utilities/Helper';
import pricingCheck from '../../../../Asests/pricing-images/pricing-tick.png';
import { DI } from '../../../../Core';
import { QuestionMarkInverseMinor } from '@shopify/polaris-icons';
import { useTranslation } from 'react-i18next';

const PlanCard = (props: PlanCardProps) => {
    const { t } = useTranslation();
    const { plan, type, activePlanName, activePlanID, setFeatureModal, buttonPrimary, setButtonPrimary, buttonLoading, activePlanData, setSettlementModal, handlePlanModal } = props;

    const pricingBadge = (tag: any): any => {
        return (
            <InlineStack gap='100' blockAlign='center'>
                <Text as="span">{t(tag?.type?.charAt(0)?.toUpperCase() + tag?.type?.slice(1))}</Text>
                <div style={{ cursor: 'pointer' }}>
                    <Tooltip dismissOnMouseOut content={t(tag?.message)}>
                        <Icon source={QuestionMarkInverseMinor} tone='interactive' />
                    </Tooltip>
                </div>
            </InlineStack>
        )
    }

    return (
        <div className='Custom-Pricing--Card'>
            <div className={plan?.badge ? 'Custom-Pricing--Popular' : ""}>
                <Card roundedAbove='sm'>
                    <div className='Custom-Alpha-Card__Section'>
                        {
                            plan?.badge &&
                            <div className='Custom--Pricing-Popular-Badge'>
                                <Text as='p'>{t("Most Popular")}</Text>
                            </div>
                        }
                        <BlockStack gap="500">
                            <InlineStack align='center' gap="200">
                                <Text as='p' fontWeight='semibold'>{t(plan?.title) || 'N/A'}</Text>
                                {
                                    (activePlanName === plan?.title && activePlanID === plan?.plan_id) ?
                                        <Badge tone='attention'>{t("Current Plan")}</Badge> : <></>
                                }
                                {
                                    plan?.tag &&
                                    <div className='Custom__Badge--Recommended'>
                                        <Badge tone="attention">{pricingBadge(plan?.tag)}</Badge>
                                    </div>
                                }
                            </InlineStack>
                            <BlockStack inlineAlign='center' gap="200">
                                {
                                    Object.values(plan?.discounts)?.length > 0 ?
                                        <InlineStack gap="200" wrap={false} blockAlign='baseline'>
                                            <InlineStack gap="200" wrap={false} blockAlign='baseline'>
                                                {
                                                    plan?.title?.toLowerCase() !== 'free' &&
                                                    <Text variant="headingLg" as="p">
                                                        <Text as='span' tone='subdued'>
                                                            <s>${Math.ceil(+plan?.custom_price / 12 ?? 0)}</s>
                                                        </Text>
                                                    </Text>
                                                }
                                                {
                                                    plan?.title !== 'Free' ?
                                                        <InlineStack gap="100">
                                                            {
                                                                plan?.discounts?.[0]?.type == 'percentage' ?
                                                                    FormatPriceAmount(((plan?.custom_price - ((plan?.discounts[0]?.value / 100) * plan?.custom_price)) / 12).toFixed(2))
                                                                    :
                                                                    plan?.discounts[0]?.type == 'fixed' &&
                                                                    FormatPriceAmount(((plan?.custom_price - plan?.discounts[0]?.value) / 12).toFixed(2))
                                                            }
                                                        </InlineStack>
                                                        :
                                                        <Text as='p' fontWeight='semibold'>${(+plan?.custom_price / 12 || 0).toFixed(2)}</Text>
                                                }
                                            </InlineStack>
                                            <Text as='p' tone='subdued'>/{t("mo")}</Text>
                                        </InlineStack>
                                        :
                                        <InlineStack wrap={false} gap="200" blockAlign='baseline'>
                                            <Text variant="heading3xl" as="p" fontWeight='semibold'>
                                                ${plan?.custom_price || 0}
                                            </Text>
                                            <Text as='p' tone='subdued'>/{t("mo")}</Text>
                                        </InlineStack>
                                }
                                <Text as='p' fontWeight='semibold'>
                                    {
                                        plan?.services_groups?.[0]?.services?.[0]?.prepaid?.service_credits || 0
                                    }
                                    {
                                        plan?.services_groups?.[0]?.services?.[0]?.prepaid?.service_credits || 0 > 9 ? ` ${t("orders")} ` : ` ${t("order")} `
                                    }
                                    {t("per month")}
                                </Text>
                            </BlockStack>
                            <Divider />
                            <BlockStack gap="400">
                                {
                                    plan?.features && <Text as='p' fontWeight='semibold'>{t("What’s included on")} {t(plan?.title) || 'N/A'}?</Text>
                                }
                                <BlockStack gap="200">
                                    {
                                        plan?.features?.slice(0, 4)?.map((feature: any, idx: number) => {
                                            return (
                                                <InlineStack blockAlign='center' gap="200" wrap={false} key={idx}>
                                                    <div>
                                                        <img height='10px' width='12px' alt='check' src={pricingCheck} />
                                                    </div>
                                                    <Text as='p' tone='subdued'>
                                                        <span dangerouslySetInnerHTML={{ __html: t(feature?.feature?.trim()) }}></span>
                                                    </Text>
                                                </InlineStack>
                                            );
                                        })
                                    }
                                </BlockStack>
                                <Link removeUnderline onClick={() => setFeatureModal({ open: true, features: plan?.features })}>{t("View all features")}</Link>
                            </BlockStack>
                            {
                                activePlanName === plan?.title && activePlanID == plan?.plan_id ?
                                    <div
                                        onMouseLeave={() => {
                                            let tempYearlyPrimary = { ...buttonPrimary };
                                            tempYearlyPrimary[plan?.plan_id] = false;
                                            setButtonPrimary({ ...tempYearlyPrimary });
                                        }}
                                    >
                                        <Button
                                            size='large'
                                            fullWidth
                                            onMouseEnter={() => {
                                                let tempYearlyPrimary = { ...buttonPrimary };
                                                tempYearlyPrimary[plan?.plan_id] = true;
                                                setButtonPrimary({ ...tempYearlyPrimary });
                                            }}
                                            loading={buttonLoading[plan?.plan_id]}
                                            variant={buttonPrimary[plan?.plan_id] ? 'primary' : undefined}
                                            disabled={plan?.title === activePlanName || plan?.active == false}
                                            onClick={() => {
                                                activePlanData?.settlement_info && Object.values(activePlanData?.settlement_info).length > 0 ?
                                                    setSettlementModal({
                                                        open: true,
                                                        planId: plan?.plan_id,
                                                        data: activePlanData?.settlement_info
                                                    })
                                                    :
                                                    // plan?.title === 'Free' ?
                                                    // choosePlan(plan?.plan_id, 'Free') :
                                                    // choosePlan(plan?.plan_id)
                                                    handlePlanModal(plan)
                                            }
                                            }
                                        >
                                            {t("Current Plan")}
                                        </Button>
                                    </div>
                                    :
                                    plan?.title == activePlanName &&
                                        plan?.plan_id == activePlanID ||
                                        plan?.active == false ?
                                        <div
                                            onMouseLeave={() => {
                                                let tempYearlyPrimary = { ...buttonPrimary };
                                                tempYearlyPrimary[plan?.plan_id] = false;
                                                setButtonPrimary({ ...tempYearlyPrimary });
                                            }}
                                        >
                                            <Tooltip content={(plan?.active == false && plan?.message && plan?.message !== "") ? plan?.message : t('Plan unavailable due to lower order limit than current order usage')} dismissOnMouseOut>
                                                <Button
                                                    size='large'
                                                    fullWidth
                                                    onMouseEnter={() => {
                                                        let tempYearlyPrimary = { ...buttonPrimary };
                                                        tempYearlyPrimary[plan?.plan_id] = true;
                                                        setButtonPrimary({ ...tempYearlyPrimary });
                                                    }}
                                                    loading={buttonLoading[plan?.plan_id]}
                                                    variant={buttonPrimary[plan?.plan_id] || plan?.badge !== '' ? 'primary' : undefined}
                                                    disabled={
                                                        plan?.title == activePlanName &&
                                                        plan?.plan_id == activePlanID ||
                                                        plan?.active == false
                                                    }
                                                    onClick={() => {
                                                        activePlanData?.settlement_info && Object.values(activePlanData?.settlement_info).length > 0 ?
                                                            setSettlementModal({
                                                                open: true,
                                                                planId: plan?.plan_id,
                                                                data: activePlanData?.settlement_info
                                                            })
                                                            :
                                                            handlePlanModal(plan)
                                                    }
                                                    }
                                                >
                                                    {
                                                        plan?.title?.toLowerCase() === 'Free' ? t("Try For Free") :
                                                            t("Buy Now")
                                                    }
                                                </Button>
                                            </Tooltip>
                                        </div>
                                        :
                                        <div
                                            onMouseLeave={() => {
                                                let tempMonthlyPrimary = { ...buttonPrimary };
                                                tempMonthlyPrimary[plan?.plan_id] = false;
                                                setButtonPrimary({ ...tempMonthlyPrimary });
                                            }}
                                        >
                                            <Button
                                                size='large'
                                                fullWidth
                                                onMouseEnter={() => {
                                                    let tempMonthlyPrimary = { ...buttonPrimary };
                                                    tempMonthlyPrimary[plan?.plan_id] = true;
                                                    setButtonPrimary({ ...tempMonthlyPrimary });
                                                }}
                                                loading={buttonLoading[plan?.plan_id]}
                                                variant={buttonPrimary[plan?.plan_id] ? 'primary' : undefined}
                                                disabled={
                                                    plan?.title == activePlanName &&
                                                    plan?.plan_id == activePlanID ||
                                                    plan?.active == false
                                                }
                                                onClick={() => {
                                                    activePlanData?.settlement_info && Object.values(activePlanData?.settlement_info).length > 0 ?
                                                        setSettlementModal({
                                                            open: true,
                                                            planId: plan?.plan_id,
                                                            data: activePlanData?.settlement_info
                                                        })
                                                        :
                                                        handlePlanModal(plan)
                                                }}
                                            >
                                                {t("Buy Now")}
                                            </Button>
                                        </div>
                            }
                        </BlockStack>
                    </div>
                </Card>
            </div>
        </div>
    )
}

export default DI(PlanCard)